import React from 'react';

import { UILoader } from '@futrli/ui-components';

import { InitialOnboardingLoader } from '../../../../../../skeleton/src/onboarding/components/initial-onboarding-nav';
import { useDetailContext } from '../../context/detail-context/detail-context';

import styles from './forecasting-loader-container.scss';

interface Props {
  children: React.ReactNode;
  isOnboardingPage?: boolean;
}

export const ForecastingLoaderContainer = ({ children, isOnboardingPage }: Props) => {
  const { isInitialDataLoading } = useDetailContext();

  if (isInitialDataLoading) {
    if (isOnboardingPage) {
      return <InitialOnboardingLoader />;
    }
    return (
      <div className={styles.loadingContainer}>
        <UILoader isFull={true} />
      </div>
    );
  }

  return <>{children}</>;
};
